import { render, staticRenderFns } from "./LoadingAlert.vue?vue&type=template&id=2bc56c66&"
import script from "./LoadingAlert.vue?vue&type=script&lang=ts&"
export * from "./LoadingAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports